import type { SVGProps } from 'react';

const ExclusiveCloseButtonIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width={44} height={44} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="m23.828 21.998 6.848-6.848a1.295 1.295 0 0 0-1.83-1.83l-6.848 6.848-6.848-6.848a1.295 1.295 0 0 0-1.83 1.83l6.848 6.848-6.848 6.848a1.295 1.295 0 0 0 1.832 1.83l6.849-6.848 6.848 6.848a1.3 1.3 0 0 0 1.832 0 1.295 1.295 0 0 0 0-1.83l-6.853-6.848Z"
            fill="#000"
        />
        <mask
            id="a"
            style={{
                maskType: 'luminance'
            }}
            maskUnits="userSpaceOnUse"
            x={12}
            y={12}
            width={20}
            height={20}>
            <path
                d="m23.828 21.998 6.848-6.848a1.295 1.295 0 0 0-1.83-1.83l-6.848 6.848-6.848-6.848a1.295 1.295 0 0 0-1.83 1.83l6.848 6.848-6.848 6.848a1.295 1.295 0 0 0 1.832 1.83l6.849-6.848 6.848 6.848a1.3 1.3 0 0 0 1.832 0 1.295 1.295 0 0 0 0-1.83l-6.853-6.848Z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#a)">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 0h44.25v44.25H0V0Z" fill="#fff" />
        </g>
    </svg>
);

export default ExclusiveCloseButtonIcon;
